var exports = {
  "uW": "VoiceActivitySection.module__section___WlprY1",
  "eV": "VoiceActivitySection.module__moreCallsText___WlprY1",
  "ti": "VoiceActivitySection.module__allCallsGrid___WlprY1",
  "ux": "VoiceActivitySection.module__gridItem___WlprY1",
};

module.exports = exports;
